export default __webpack_public_path__ + "static/media/pictogramBeaconManage40.bcea180f.svg";